export default __webpack_public_path__ + "static/media/requestTalent.c90ce1e8.svg";